// src/components/ErrorBanner.js
import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * Display an error message with a dismiss button
 * 
 * @param {Object} props - Component props
 * @param {string} props.message - The error message to display
 * @param {Function} props.onDismiss - Function to call when the error is dismissed
 * @returns {JSX.Element} Rendered error banner
 */
const ErrorBanner = ({ message, onDismiss }) => {
  return (
    <div className="error-banner">
      <p>{message}</p>
      <Button 
        variant="secondary" 
        onClick={onDismiss}
      >
        Dismiss
      </Button>
    </div>
  );
};

export default ErrorBanner;